export const MOBILE_BREAK_POINT = 768;
export const TABLET_BREAK_POINT = 1024;

export type AppState =
	| 'login'
	| 'loading'
	| 'empty-dashboard'
	| 'depositing'
	| 'generating'
	| 'active-dashboard';

export type CornerType = 'topLeft' | 'topRight' | 'bottomLeft' | 'bottomRight';

export const corners = ['topLeft', 'topRight', 'bottomLeft', 'bottomRight'];

export const getRandomCornerPosition = (corner: CornerType) => {
	switch (corner) {
		case 'topLeft':
			return {
				top: `${Math.floor(Math.random() * 30)}%`,
				left: `${Math.floor(Math.random() * 30)}%`,
			};
		case 'topRight':
			return {
				top: `${Math.floor(Math.random() * 30)}%`,
				left: `${Math.floor(Math.random() * 30) + 50}%`,
			};
		case 'bottomLeft':
			return {
				top: `${Math.floor(Math.random() * 30) + 50}%`,
				left: `${Math.floor(Math.random() * 30)}%`,
			};
		case 'bottomRight':
			return {
				top: `${Math.floor(Math.random() * 30) + 50}%`,
				left: `${Math.floor(Math.random() * 30) + 50}%`,
			};
		default:
			return { top: '0%', left: '0%' };
	}
};

export const shuffleArray = (array: any[]) => {
	const newArray = [...array];
	for (let i = newArray.length - 1; i > 0; i--) {
		const j = Math.floor(Math.random() * (i + 1));
		[newArray[i], newArray[j]] = [newArray[j], newArray[i]];
	}
	return newArray;
};
